export enum UEPMeasure {
  Each = 0,
  KG = 1,
  Litre = 2,
}

export const UEPMeasureDisplay: Record<UEPMeasure, string> = {
  [UEPMeasure.Each]: 'each',
  [UEPMeasure.KG]: 'per kg',
  [UEPMeasure.Litre]: 'per litre',
};

export const getUEPMeasureText = (measure: UEPMeasure): string => {
  return UEPMeasureDisplay[measure] || 'each';
};
